export const parseAllowedCountries = (configString: string): string[] => {
    if (configString.indexOf('{{') > -1) {
        return process.env.REACT_APP_ALLOWED_COUNTRIES 
            ? process.env.REACT_APP_ALLOWED_COUNTRIES.split(',').map(c => c.trim().toUpperCase())
            : [];
    }
    if (!configString || configString.trim() === '') {
        return []; 
    }
    return configString.split(',').map(c => c.trim().toUpperCase()).filter(c => c !== '');
};